import Header from './components/Header';
import Hero from './components/Hero';
import Trending from './components/Trending';
import Categories from './components/Categories';
import FreshFeed from './components/FreshFeed';
import Reader from './components/Reader';
import Faq from './components/Faq';
import SubmitForm from './components/SubmitForm';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <Trending />
        <Categories />
        <FreshFeed />
        <Reader />
        <Faq />
        <SubmitForm />
      </main>
      <Footer />
    </div>
  );
}